import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { ContentWrapper } from './PageWrapper.elements'

function PageWrapper(props) {
  // Destructure
  const { children, ...rest } = props

  return <ContentWrapper {...rest}>{children}</ContentWrapper>
}

// Default Props
PageWrapper.defaultProps = {
  children: '',
}

// Proptypes Validation
PageWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
}

export default PageWrapper
